<template>
	<div class="card">
		<div class="card-body">
			<div class="row align-items-center">
				<div class="col-md-2 col-6">
					<base-input label="วันที่">
						<flat-picker class="form-control datepicker" v-model="startDate" />
					</base-input>
				</div>
				<div class="col-md-2 col-6">
					<base-input label="ถึง">
						<flat-picker class="form-control datepicker" v-model="endDate" />
					</base-input>
				</div>
				<div class="col-md-2 col-6">
					<base-input label="ค้นหา" labelClasses="text-white" placeholder="ค้นหา ..." v-model="searchQuery" />
				</div>
				<div class="col-md-6 col-12 search">
					<base-button type="default" @click="submitSearch()" :disabled="loading">
						ค้นหา
					</base-button>
				</div>
			</div>

			<div class="row mt-4">
				<div class="col-md-12">
					<bank-tx-list-panel :_searchQuery="searchQuery" :count="dataCount" :data="transactions" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import flatPicker from 'vue-flatpickr-component'
import BankTxListPanel from '../backend-components/BankTx/BankTxListPanel'

import moment from 'moment'
import tablePagination from '../mixins/tablePagination'
import BankTxService from '../services/bankTx.service'

export default {
	components: {
		flatPicker,
		BankTxListPanel,
	},
	data() {
		return {
			loading: false,
			startDate: moment().format('YYYY-MM-DD'),
			endDate: moment().format('YYYY-MM-DD'),
			searchQuery: '',

			dataCount: 0,
			transactions: [],
		}
	},
	methods: {
		async submitSearch() {
			this.loading = true

			try {
				const res = await BankTxService.getTxes({
					start: this.startDate,
					end: this.endDate,
				})

				this.dataCount = res.length
				this.transactions = res
			} finally {
				this.loading = false
			}
		},
	},
	created() {
		this.submitSearch()
	},
}
</script>
